
import { Component, Vue } from "nuxt-property-decorator";
import ContentPageLayout from "~/components/molecules/display/ContentPageLayout.vue";
import { generateMetaTags } from "~/operations/meta-helper-functions";
import type { JumpNavItem } from "~/types/ContentPage";

@Component({
  scrollToTop: true,
  components: {
    ContentPageLayout,
  },
})
export default class PelletheizungNachteileVorteile extends Vue {
  head() {
    return {
      ...generateMetaTags(this.$route.path, "pelletheizung-vorteile-nachteile"),
      link: [{ rel: "canonical", href: this.$route.path }],
    };
  }

  get jumpNavItems(): JumpNavItem[] {
    return [
      {
        name: "Vorteile",
        title: "Springen Sie zum Bereich: Vorteile",
        href: { hash: "#anker-vorteile" },
      },
      {
        name: "Nachteile",
        title: "Springen Sie zum Bereich: Nachteile",
        href: { hash: "#anker-nachteile" },
      },
      {
        name: "Pelletheizung Nachteile vs. Vorteile",
        title: "Springen Sie zum Bereich: Bewertung (Pro vs. Kontra)",
        href: { hash: "#anker-bewertung" },
      },
      {
        name: "Pelletheizung Nachteile minimieren",
        title: "Springen Sie zum Bereich: Lösungen",
        href: { hash: "#anker-loesungen" },
      },
      {
        name: "Richtige Entscheidung trotz Pelletheizung Nachteile",
        title: "Springen Sie zum Bereich: Entscheidung",
        href: { hash: "#anker-entscheidung" },
      },
    ];
  }
}
